export default "__VITE_ASSET__CmVR5Sqy__";